import api from './api';

export const reportingService = {
    // Özel rapor oluşturma
    createCustomReport: async (reportType, startDate, endDate) => {
        const response = await api.get(`/admin/reports?type=${reportType}&start_date=${startDate}&end_date=${endDate}`);
        return response.data;
    },

    // Rapor verilerini dışa aktarma (simülasyon)
    exportReportData: async (reportData, format) => {
        // Burada gerçek export işlemi yapılabilir, şimdilik simüle ediyoruz
        console.log(`Exporting report as ${format}`, reportData);

        // CSV export simülasyonu
        if (format === 'csv') {
            let csvContent = "data:text/csv;charset=utf-8,";
            if (reportData.report && reportData.report.length > 0) {
                const headers = Object.keys(reportData.report[0]).join(',');
                const rows = reportData.report.map(row =>
                    Object.values(row).map(value => `"${value}"`).join(',')
                ).join('\n');
                csvContent += headers + '\n' + rows;
            }

            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `report_${new Date().getTime()}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        return { success: true, message: `Report exported as ${format}` };
    },

    // Rapor istatistiklerini getir
    fetchReportStatistics: async (reportType, startDate, endDate) => {
        const response = await api.get(`/admin/reports?type=${reportType}&start_date=${startDate}&end_date=${endDate}`);
        return response.data;
    },

    // Hızlı raporlar için preset tarih aralıkları
    getQuickDateRanges: () => {
        const today = new Date();
        return {
            last7Days: {
                start: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                end: today.toISOString().split('T')[0]
            },
            last30Days: {
                start: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                end: today.toISOString().split('T')[0]
            },
            last90Days: {
                start: new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                end: today.toISOString().split('T')[0]
            },
            thisMonth: {
                start: new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0],
                end: new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0]
            }
        };
    }
};